import { useMutation, useQuery } from '@tanstack/react-query'
import AXIOS_INSTANCE from '../api/axiosInstance'
import { queryClient } from '../store/provider/TanStackProvider'
import { AllergyDataMock } from '../types/allergy.type'
import { GeneralResMock } from '../types/general.type'

type AllergyTypes = {
  patientId?: string
  id?: string
}
export const useAllergy = (arg?: AllergyTypes) => {
  const patient_id = arg?.patientId
  const id = arg?.id
  const { data: allergies, isLoading } = useQuery({
    queryFn: async () => {
      const { data } = await AXIOS_INSTANCE.get<GeneralResMock<AllergyDataMock[]>>(`allergies`, {
        params: { ...(patient_id && { patient_id }) }
      })
      return data.data
    },
    queryKey: ['allergies', { patient_id }]
  })

  const { data: singleAllergy } = useQuery({
    enabled: !!id,
    queryFn: async () => {
      const { data } = await AXIOS_INSTANCE.get<GeneralResMock<AllergyDataMock>>(`/allergies/${id}`)
      return data
    },
    queryKey: ['allergies', { id }]
  })

  const { mutateAsync: createAllergy } = useMutation({
    mutationFn: async (formVal: any) => {
      const { data } = await AXIOS_INSTANCE.post(`allergies`, formVal, {
        headers: { 'Content-Type': 'application/vnd.api+json' }
      })
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['allergies'] })
    }
  })

  const { mutateAsync: updateAllergy } = useMutation({
    mutationFn: async ({ formVal, id }: { formVal: any; id: string }) => {
      await AXIOS_INSTANCE.patch(`allergies/${id}`, formVal, {
        headers: { 'Content-Type': 'application/vnd.api+json' }
      })
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['allergies', { id }] })
  })

  const { mutateAsync: deleteAllergy } = useMutation({
    mutationFn: async ({ id }: { id: string }) => {
      await AXIOS_INSTANCE.delete(`allergies/${id}`)
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['allergies'] })
  })
  return { allergies, createAllergy, deleteAllergy, isLoading, singleAllergy, updateAllergy }
}
